import { Box } from "@mui/system";

export const Gap = (width, height) => <Box sx={{ width, height }} />;
